import { render } from "./sectione.vue?vue&type=template&id=c765d05a"
import script from "./sectione.vue?vue&type=script&lang=js"
export * from "./sectione.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__